module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h3', {
    staticClass: "title fg-darkCyan"
  }, [_vm._v("Loading 加载动画")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.showLoading
    }
  }, [_vm._v("Loading")]), _vm._v(" "), _c('p', [_vm._v("Script")]), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("showLoading() {\n  this.$showLoading() // 显示加载框\n  setTimeout(() => {\n    this.$hideLoading()   // 关闭加载框\n  }, 5000)\n}")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ac77681"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pluginsDemo/loading.vue
// module id = 396
// module chunks = 1